module.exports = __webpack_public_path__ + "static/media/bank9.7b0d921b.png";